module.exports = __webpack_public_path__ + "media/images/home-banners/dove-2516641_1920-af7865e41da4f3ce1e0af12b3665e6d6.jpg";